import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
// import { useAuth } from '../modules/auth'
// import { checkIsAdministrator } from '../../_metronic/helpers/FunctionHelpers'

const SupperAdminRoutes = () => {
  // const { currentUser } = useAuth();
  // const isAdministrator = checkIsAdministrator(currentUser);

  const RegionsPage = lazy(() => import('../modules/supper-admin/region-management/RegionsPage'))
  const AccountsPage = lazy(() => import('../modules/supper-admin/account-management/AccountsPage'))
  // const SalesPage = lazy(() => import('../modules/supper-admin/sales/SalesPage'))
  const PartnersPage = lazy(() => import('../modules/supper-admin/partner/PartnersPage'))
  // const InstallmentPackagesPage = lazy(() => import('../modules/supper-admin/installment-package/InstallmentPackagesPage'))
  const ReportPage = lazy(() => import('../modules/supper-admin/report/ReportPage'))
  const DepositReportPage = lazy(() => import('../modules/supper-admin/report-deposit/ReportPage'))
  const ManageClientPage = lazy(() => import('../modules/supper-admin/manage-client/ManageClientPage'))
  // const TrainingPage = lazy(() => import('../modules/training/training-management/TrainingPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/report-sale/report-manager' />} />
        <Route
          path='region-management/*'
          element={
            <SuspensedView>
              <RegionsPage />
            </SuspensedView>
          }
        />
        <Route
          path='account-management/*'
          element={
            <SuspensedView>
              <AccountsPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='sales/*'
          element={
            <SuspensedView>
              <SalesPage />
            </SuspensedView>
          }
        />  */}
        <Route
          path='report-sale/*'
          element={
            <SuspensedView>
              <ReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='report-deposit/*'
          element={
            <SuspensedView>
              <DepositReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='manage-client/*'
          element={
            <SuspensedView>
              <ManageClientPage />
            </SuspensedView>
          }
        />
        <Route
          path='partners/*'
          element={
            <SuspensedView>
              <PartnersPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='installment-package/*'
          element={
            <SuspensedView>
              <InstallmentPackagesPage />
            </SuspensedView>
          }
        /> */}
        {/* {
          isAdministrator && <Route
            path='training-management/*'
            element={
              <SuspensedView>
                <TrainingPage />
              </SuspensedView>
            }
          />
        } */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { SupperAdminRoutes }
